import React from 'react';
import { Card, Typography, Empty } from 'antd';
import { ShoppingOutlined } from '@ant-design/icons';

const { Title, Paragraph } = Typography;

const Products = () => (
  <div>
    <Title level={3}>Productos</Title>
    <Card bordered={false} style={{ borderRadius: 8, textAlign: 'center', padding: 40 }}>
      <Empty
        image={<ShoppingOutlined style={{ fontSize: 64, color: '#197278' }} />}
        description={
          <div>
            <Title level={4} style={{ marginTop: 16 }}>Catálogo de Productos</Title>
            <Paragraph type="secondary">
              ~4,670 productos activos sincronizados desde Odoo. Incluye 10 departamentos,
              574 productos base y 3,925 variantes con código de barras.
            </Paragraph>
            <Paragraph type="secondary">Disponible en Fase 5 (conexión con Odoo API)</Paragraph>
          </div>
        }
      />
    </Card>
  </div>
);

export default Products;
